import { useEffect, useRef, useState } from "react";
export function useFileDragAndDropUploader(onFile) {
    const [isDragging, setIsDragging] = useState(false);
    const dragCounter = useRef(0);
    useEffect(() => {
        const handleDragOver = (e) => {
            e.preventDefault();
        };
        const handleDragEnter = (e) => {
            e.preventDefault();
            dragCounter.current += 1;
            setIsDragging(true);
        };
        const handleDragLeave = (e) => {
            e.preventDefault();
            dragCounter.current -= 1;
            if (dragCounter.current <= 0) {
                setIsDragging(false);
            }
        };
        const handleDrop = (e) => {
            e.preventDefault();
            dragCounter.current = 0;
            setIsDragging(false);
            if (e.dataTransfer?.files?.length) {
                Array.from(e.dataTransfer.files).forEach(onFile);
            }
        };
        window.addEventListener("dragover", handleDragOver);
        window.addEventListener("dragenter", handleDragEnter);
        window.addEventListener("dragleave", handleDragLeave);
        window.addEventListener("drop", handleDrop);
        return () => {
            window.removeEventListener("dragover", handleDragOver);
            window.removeEventListener("dragenter", handleDragEnter);
            window.removeEventListener("dragleave", handleDragLeave);
            window.removeEventListener("drop", handleDrop);
        };
    }, [onFile]);
    return { isDragging };
}
